import { render, staticRenderFns } from "./WallSponsorsBlock.vue?vue&type=template&id=c5378d98"
import script from "./WallSponsorsBlock.vue?vue&type=script&lang=js"
export * from "./WallSponsorsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports